import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.auth');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-auth',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.auth/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.auth-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: radial-gradient(circle at 14% 8%, rgba(0, 106, 166, 0.12), transparent 32rem), radial-gradient(circle at 90% 92%, rgba(229, 120, 54, 0.07), transparent 26rem), linear-gradient(145deg, #edf4f7 0%, #f8fafb 50%, #eef3f5 100%);
}

.auth-shell {
  margin-block: auto;
  border: 1px solid rgba(199, 211, 217, 0.88);
  box-shadow: 0 28px 80px rgba(13, 43, 58, 0.14), 0 3px 10px rgba(13, 43, 58, 0.05);
}

.auth-shell > * {
  min-width: 0;
}

.auth-intro {
  background: linear-gradient(150deg, rgba(24, 72, 97, 0.98) 0%, rgba(13, 48, 67, 0.99) 52%, #0a2737 100%);
}

.auth-brand-card {
  border: 1px solid rgba(255, 255, 255, 0.9);
  box-shadow: 0 14px 34px rgba(2, 24, 36, 0.2);
}

.auth-copy {
  word-break: keep-all;
  overflow-wrap: break-word;
}

.auth-trust-dot {
  display: inline-block;
  width: 0.45rem;
  height: 0.45rem;
  flex: 0 0 auto;
  border-radius: 999px;
  background: #71c5ea;
  box-shadow: 0 0 0 4px rgba(113, 197, 234, 0.09);
}

.auth-route {
  background: rgba(255, 255, 255, 0.985);
}

@media (max-width: 1023px) {
  .auth-shell {
    max-width: 34rem;
  }
}`],
})
export class LayoutAuthComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }
}

export default LayoutAuthComponent;